import { Fragment } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { SpinnerComponent } from "../../../lib/spinner";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { MadfarmInput } from "../../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import { destinationOffice, entryMeansOptions, sot, yearOptions } from "../../../utils";
import { GetDistinta, setAttachmentsReport, setDestinationOfficeReport, setEndNumberReport, setEntryChannelReport, setHeadQuarterReport, setStartNumberReport, setYearReport } from "../entry/slice";

interface Props {
    close: () => void;
    attachments: boolean
}

export function FormDistintaEntrata(props: Props) {
    const dispatch = useAppDispatch()
    if (props.attachments) {
        dispatch(setAttachmentsReport(true))
    }
    else {
        dispatch(setAttachmentsReport(false))
    }

    const entryProtocolState = useAppSelector(state => state.entryProtocol)
    const isLoading = entryProtocolState.getDistintaStatus === 'loading'
    return (
        <Fragment>
            <div
                className="bg-brandPrimary-100 p-6 flex flex-col gap-6"
            >
                {isLoading && (
                    <div className="distinta-loading-overlay">
                        <SpinnerComponent size="medium" />
                    </div>
                )}
                <div className="grid grid-cols-2 gap-6">
                    <MadfarmStaticSelect
                        customZIndex={9999}
                        noOptionsMessage=""
                        label="Sede/Ufficio"
                        value={entryProtocolState.reportRequestFilters.headQuarterOffice}
                        placeholder={'Sede/Ufficio'}
                        options={sot}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setHeadQuarterReport(newValue))
                        }}
                    />
                    <MadfarmStaticSelect
                        customZIndex={9999}
                        label="Anno"
                        noOptionsMessage=""
                        placeholder={'Anno'}
                        options={yearOptions}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setYearReport(newValue))
                        }}
                        value={entryProtocolState.reportRequestFilters.year}
                    />
                </div>
                <div className="grid grid-cols-2 gap-6">
                    <MadfarmInput
                        label={'N. Protocollo iniziale'}
                        placeholder="Specificare numero"
                        onChangeText={(text) => { dispatch(setStartNumberReport(text)) }}
                    />
                    <MadfarmInput
                        label={'N. Protocollo finale'}
                        placeholder="Specificare numero"
                        onChangeText={(text) => { dispatch(setEndNumberReport(text)) }}
                    />
                </div>

                <div className="grid grid-cols-2 gap-6">
                    <MadfarmStaticSelect
                        customZIndex={9999}
                        noOptionsMessage=""
                        label="Mezzo Entrata"
                        placeholder={'Mezzo Entrata'}
                        options={entryMeansOptions}
                        onChange={(value) => dispatch(setEntryChannelReport(value))}
                        value={entryProtocolState.reportRequestFilters.entryChannel}
                    />
                    <MadfarmStaticSelect
                        customZIndex={9999}
                        noOptionsMessage=""
                        label="Destinatario consegna (Sede / Ufficio / WS)"
                        placeholder={'Destinatario'}
                        options={destinationOffice}
                        onChange={(value) => dispatch(setDestinationOfficeReport(value))}
                        value={entryProtocolState.reportRequestFilters.destinationOffice}
                    />
                </div>

            </div>
            <div className="p-6 flex flex-row justify-end w-full items-center gap-2">
                <ButtonComponent
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="gray"
                    disabled={isLoading}
                    onClick={() => {
                        props.close();
                    }}
                />
                <ButtonComponent
                    size="md"
                    variant="solid"
                    iconPosition="off"
                    label="Stampa"
                    color="orange"
                    disabled={isLoading}
                    onClick={() => {
                        dispatch(GetDistinta(entryProtocolState.reportRequestFilters))
                    }}
                />
            </div>
        </Fragment >
    )
}